import React, { useEffect, useState } from "react";
import { Dropdown, Table } from "react-bootstrap";
import FilterIcon from "../../../icons/FilterIcon";
import SearchIcon from "../../../icons/SearchIcon";
import "../style.scss";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { getMonthlyPaymentHistory } from "../../../services/paymentAndHistory.service";
import { AxiosError } from "axios";
import { toast } from "react-toastify";

export default function Month() {
  const [selectedYear, setSelectedYear] = useState<string>("");
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [params] = useSearchParams();
  const currentYear = new Date().getFullYear();
  const [monthlyHistory, setMonthlyHistory] = useState([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [currentPage, setCurrentPage] = useState<number>(1); // Track current page
  const [totalItems, setTotalItems] = useState<number>(0); // Track total number of items
  const itemsPerPage = 10; // Number of items per page
  const [filterOption, setFilterOption] = useState<string>("newToOld");
  const navigate = useNavigate();

  let monthArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  useEffect(() => {
    const year = params.get("year") || `${currentYear}`;
    const month = params.get("month") || "1";

    setSelectedYear(year);
    setSelectedMonth(month);
    getMonthlyHistory(currentPage, searchTerm, filterOption);
  }, [selectedYear, selectedMonth, searchTerm]);

  const getMonthlyHistory = async (
    page: number,
    searchTerm: string,
    filterOption: string
  ) => {
    let skip = (page - 1) * itemsPerPage;

    try {
      const payload = {
        year: selectedYear,
        month: selectedMonth,
        search: searchTerm,
        sortOrder: filterOption,
        skip,
        limit: itemsPerPage,
      };

      const result = await getMonthlyPaymentHistory(payload);
      if (result.status == 200) {
        if (result?.data?.data) {
          setMonthlyHistory(result?.data?.data);
        }
      } else if (result.status == 404) {
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.responseMessage);
      }
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  // Update filter option state
  const handleFilterChange = (filter: string) => {
    setFilterOption(filter);
    setCurrentPage(1); // Reset to page 1 when filter changes

    getMonthlyHistory(currentPage, searchTerm, filter);
  };

  const viewClassHistory = (className: string, classId: any) => {
    navigate(`/payment-history/month/classes?className=${className}&year=${selectedYear}&month=${selectedMonth}&classId=${classId}`);
  };


  return (
    <div className="monthWrapper pt-3">
      <div className="container">
        <ul className="breadcrumbWrapper">
          <li>
            <Link to={"/payment-history"}>Payments & History</Link>
          </li>{" "}
          /
          <li>
            <span>
              {monthArray[parseInt(selectedMonth) - 1]} {selectedYear}
            </span>
          </li>
        </ul>
        <div className="bgFormColor p-4 my-4">
          <div className="searchTitleWrap d-flex justify-content-between align-items-start">
            <label>
              {monthArray[parseInt(selectedMonth) - 1]} {selectedYear}
            </label>
            <div className="searchWrap d-flex gap-2 align-items-center">
              <form>
                <button>
                  <SearchIcon />
                </button>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search check-in ..."
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
              </form>

              <div className="filterDropdown">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-basic">
                    <FilterIcon />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <button
                      className={filterOption === "newToOld" ? "active" : ""}
                      onClick={() => handleFilterChange("newToOld")}
                    >
                      Date, new to old
                    </button>
                    <button
                      className={filterOption === "oldToNew" ? "active" : ""}
                      onClick={() => handleFilterChange("oldToNew")}
                    >
                      Date, old to new
                    </button>
                    <button
                      className={filterOption === "aToZ" ? "active" : ""}
                      onClick={() => handleFilterChange("aToZ")}
                    >
                      Alphabetically, A-Z
                    </button>
                    <button
                      className={filterOption === "zToA" ? "active" : ""}
                      onClick={() => handleFilterChange("zToA")}
                    >
                      Alphabetically, Z-A
                    </button>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="table-responsive">
            <Table className="tableWrapper">
              <thead>
                <tr>
                  <th>Class name</th>
                  <th>Check-ins</th>
                  <th>No-Show</th>
                  <th>Cancelled classes</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {monthlyHistory?.length > 0 ? (
                  monthlyHistory.map((data: any, index) => (
                    <tr>
                      <td>
                        <span className="underline">
                          {data?.className.charAt(0).toUpperCase() +
                            data?.className.slice(1)}
                        </span>
                      </td>
                      <td>{data?.totalCheckins}</td>
                      <td>{data?.noShow}</td>
                      <td>{data?.totalCancelled}</td>
                      <td>
                        <button className="confirmBtn" onClick={() => viewClassHistory(data?.className, data?.classId)}>History</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No history found for this month.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
}
